import { Skeleton } from "primereact/skeleton";
import "./OfferCardShimmer.scss"

export const OfferCardShimmer = () => {
  return (
    <div className="shimmer_ui">
      {
        [...Array(4)].map((e, i) =>
          <div className={`case_law shimmer-pulsate`} key={`OfferCard${i}`}  >
        <span className="card-imgs shimmer-pulsate"> <img className="image1 shimmer-pulsate" alt=''  /> </span>

      
             <h5 className='law_list_head text-elipsis l3 shimmer-pulsate'>
                  <span>Speaker 1, Speaker 2, Speaker 3, Speaker 4</span>
                   <span>  more</span>
             </h5>
            <h6 className='law_list_subhead shimmer-pulsate'>Heading1</h6>
     </div> 

        )
      }
    </div>
  )
}

export default OfferCardShimmer


